export default __webpack_public_path__ + "static/media/grayarea-banner-logo-left-white.34e083b5.png";